import { render, staticRenderFns } from "./LoginRegisterPage.vue?vue&type=template&id=b29f03a6&scoped=true&"
import script from "./LoginRegisterPage.vue?vue&type=script&lang=ts&"
export * from "./LoginRegisterPage.vue?vue&type=script&lang=ts&"
import style0 from "./LoginRegisterPage.vue?vue&type=style&index=0&id=b29f03a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29f03a6",
  null
  
)

export default component.exports